import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { IntegrationFormState } from "../../types";
import CredentialSelector from "./CredentialSelector";

interface ApiFormProps {
  formData: IntegrationFormState;
  setFormData: (data: IntegrationFormState) => void;
}

const ApiForm = ({ formData, setFormData }: ApiFormProps) => {
  return (
    <>
      <div>
        <Label className="text-sm font-semibold">Base URL *</Label>
        <Input
          type="text"
          placeholder="e.g., https://api.example.com"
          value={formData.base_url || ""}
          onChange={(e) => setFormData({ ...formData, base_url: e.target.value })}
          className="mt-2"
        />
        <p className="text-xs text-gray-500 mt-1">
          Must be a valid URL (e.g., https://example.com)
        </p>
      </div>
      <div>
        <Label className="text-sm font-semibold">Capabilities endpoint path *</Label>
        <Input
          type="text"
          placeholder="e.g., /capabilities, /openapi.json or /api/docs"
          value={formData.capabilities_path || ""}
          onChange={(e) => setFormData({ ...formData, capabilities_path: e.target.value })}
          className="mt-2"
        />
        <p className="text-xs text-gray-500 mt-1">
          URL path to your API documentation. Can be JSON response, OpenAPI (YAML/JSON), Swagger, or
          Markdown registry
        </p>
      </div>

      <CredentialSelector formData={formData} setFormData={setFormData} />
    </>
  );
};

export default ApiForm;
